function initAlimonyCalculator()
{
    var INVALID_INPUT_RESULT = '-';
    var MAX_SALARY = 9999999;
    
    var form = $('#alimony-calculator');
    var inputSalary = form.find('input[name=salary]');
    var inputChildrenCount = form.find('select[name=childrenCount]');
    var childTemplate = form.find('script.template-child');
    var childrenParent = form.find('div.children');
    var inputResult = form.find('input[name=result]');
    
    var definition = [
        // pre, el1, el2, hi, check
        [0.14, 0.16, 0.18, 0.20, 1],
        [0.12, 0.14, 0.16, 0.18, 0.66],
        [0.10, 0.12, 0.14, 0.16, 0.55],
        [0.08, 0.10, 0.12, 0.14, 0.5]
    ];
    
    var formatNumber = function (num) {
        return (typeof Intl !== 'undefined' && typeof Intl.NumberFormat !== 'undefined') ? Intl.NumberFormat(navigator.language || 'cs-CZ').format(num.toFixed(0)) : num.toFixed(0);
    };
    
    /**
     * Výpočet srážek ze mzdy
     * @param {number} salary Čistá měsíční mzda
     * @param {number?} multiplier Modifikátor násobku
     * @param {boolean?} priorityClaims Přednostní pohledávky
     */
    var getSalarySafePart = function (salary, multiplier, priorityClaims) {
        
        if (typeof priorityClaims !== 'boolean') {
            priorityClaims = true;
        }
        
        if (typeof multiplier !== 'number') {
            multiplier = 2;
        }
        
        var lifeMin = 4620; // Výše životního minima
        var livingExpenses = 10185; // Výše normativních nákladů na bydlení
        
        var base = (lifeMin + livingExpenses) * 0.75; // Základní  částka - § 1 odst. 1 nařízení č. 595/2006 Sb.
        
        var c5c6xc15 = (lifeMin + livingExpenses) * multiplier;
        var noLimitVal = (salary - base) - c5c6xc15;
        
        var noLimit = noLimitVal > 0 ? noLimitVal : 0; // Částka, která se srazí bez omezení - § 2 nařízení č. 595/2006 Sb.
        
        var deduction = (salary - base) > c5c6xc15
            ? ( c5c6xc15 * (priorityClaims ? 0.6667 : 0.3334)  ) + noLimit
            : ((salary - base) * (priorityClaims ? 0.6667 : 0.3334 ) ) + noLimit
            ; // Provedená srážka
        return Math.floor( salary - deduction > salary ? salary : salary - deduction );
    };
    
    var calculate = function () {
    
        var salary = parseInt(inputSalary.val());
        var children = getChildren();
        
        if (typeof salary !== 'number' || isNaN(salary) || salary < 1) {
            return inputResult.val(INVALID_INPUT_RESULT);
        }
        
        var partSum = 0; // Součet hodnot
        
        children.forEach(function (ch) {
            partSum += ch.part;
        });
        
        var preTotal = salary * partSum; // Předběžná částka
        var sumMoney = 0; // Výživné v závislosti na péči
    
        children.forEach(function (ch) {
            // Rozdělení předběžné částky výživného po započítaní péče
            ch.partMoney = (preTotal * (ch.part / partSum)) * ((30.4 - ch.days) / 30.4);
            sumMoney += ch.partMoney;
            ch.el.find('input[name=chresult]').val(formatNumber(ch.partMoney) + ' Kč');
        });
        
        var salarySafePart = getSalarySafePart(salary); // Nezabavitelná částka
        console.log('Nezabavitelna castka ' + salarySafePart);
        var checkMoneyPercentage = children[0].check > partSum ? partSum : children[0].check; // Kontrolní částka (vyjádřená v %)
        console.log('Kontrolní částka (%) ' + Math.round(checkMoneyPercentage * 100) + '%');
        var checkMoney = salary * checkMoneyPercentage; // Kontrolní částka (peněžní hodnota)
        console.log('Kontrolní částka (peněžní hodnota) ' + checkMoney);
        var checkMoneyFix = salary - salarySafePart; // Orientační výše - pevná hranice
        console.log('Orientační výše - pevná hranice ' + checkMoneyFix);
        var resultAfterCheck = checkMoneyFix > checkMoney ? checkMoney : checkMoneyFix; // Výživné po kontrolní částce
        console.log('Výživné po kontrolní částce ' + resultAfterCheck);
        var result = resultAfterCheck > sumMoney ? sumMoney : resultAfterCheck;
        inputResult.val(formatNumber(result) + ' Kč');
    
        children.forEach(function (ch) {
            ch.partAfterCalculation = sumMoney > 0 ? ch.partMoney / sumMoney : 0; // Poměr rozdělení výživného v závislosti na péči či styku a podílu výživného na příjmu rodiče odpovídající věku dítěte a počtu vyživovacích povinností.
            ch.result = result * ch.partAfterCalculation; // Výše výživného pro konkrétní dítě.
            ch.el.find('input[name=chresult]').val(formatNumber(ch.result) + ' Kč');
        });
        
    };
    
    var getChildren = function () {
        
        var children = [];
        var count = childrenParent.children('div.child').length;
        var indexInDefinition = count - 1;
        childrenParent.children('div.child').each(function () {
            var child = $(this);
            var chValues = {
                part : definition[indexInDefinition][parseInt(child.find('select').val())],
                check : definition[indexInDefinition][4],
                days : parseFloat(child.find('input[name=chdays]').val()),
                el : child
            };
            if (chValues.days < 0) {
                chValues.days = 0;
            } else if (chValues > 30.4) {
                chValues = 30.4;
            }
            children.push(chValues);
        });
        
        return children;
    };
    
    var salaryEventHandler = function (e) {
        e.preventDefault();
        e.stopPropagation();
        calculate();
    };
    
    inputSalary.on('input', function (e) {
        if (this.value > MAX_SALARY) {
            this.value = MAX_SALARY;
        }
    });
    
    inputSalary.on('change', salaryEventHandler);
    inputSalary.on('keyup', salaryEventHandler);
    
    var initChildrenRows = function () {
        
        var count = parseInt(inputChildrenCount.val());
        
        childrenParent.html('');
        
        for (var i = 0; i < count; i++) {
            var holder = $(document.createElement('div'));
            holder.html(childTemplate.html());
            var child = holder.find('div.child');
            child.appendTo(childrenParent);
            holder = undefined;
            M.AutoInit(child[0]);
            M.updateTextFields(child[0]);
            
            child.find('select').change(calculate);
            child.find('input[name=chdays]').change(calculate);
            child.find('input[name=chdays]').on('change', calculate);
            child.find('input[name=chdays]').on('keyup', calculate);
            child.find('input[name=chdays]').on('input', function (e) {
                if (this.value > 30.4) {
                    this.value = 30.4;
                }
            });
        }
        
        calculate();
        
    };
    
    inputChildrenCount.change(initChildrenRows);
    
    initChildrenRows();
    
}